import React, {useContext} from "react"
import {BannerLink, LinkStyles} from "./models"
import {StyledLink} from "./components"
import {getText, replaceSiteUrl, COPY_TYPE, STRIP_TYPE, SearchBannerContext} from "../utils"

type StripOrCopy = typeof STRIP_TYPE | typeof COPY_TYPE
export interface TextProps {
    text: string
    replacements: BannerLink[] | null
    linkStyles?: LinkStyles
    type: StripOrCopy
}

export const Text = ({text, replacements, linkStyles, type}: TextProps) => {
    const {siteUrl} = useContext(SearchBannerContext)
    const textContent = buildText(text, replacements, linkStyles, type, siteUrl)
    return (
        // we need a fragment so this component always returns type of React Element
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>{typeof textContent === "string" ? textContent : textContent.map(element => element)}</>
    )
}

export function buildText(
    text: string,
    replacements: BannerLink[] | null,
    linkStyles: LinkStyles | undefined,
    type: StripOrCopy,
    siteUrl = "",
) {
    const withNbsp = text.replaceAll("&nbsp;", "\u00A0")
    if (replacements == null) return withNbsp
    const regex = RegExp("({.*?})", "g")
    // go through through text, for each {} replace with the content that is in the replacements at that index
    // if not found, leave as token
    let replacementsUsed = 0
    const parts = withNbsp.split(regex)
    const replacedSections = parts.map((string: string, partsIndex: number) => {
        const current = replacements[replacementsUsed]
        if (current == null)
            return <React.Fragment key={`no-replacements-${replacementsUsed}-${partsIndex}`}>{string}</React.Fragment>
        if (string.startsWith("{") && string.endsWith("}")) {
            replacementsUsed += 1
            if (current?.url == null) {
                return <span key={`replacement-${replacementsUsed}`}>{getText(type, string, current)}</span>
            }
            return (
                <StyledLink
                    key={`replacement-${replacementsUsed}`}
                    href={replaceSiteUrl(current?.url, siteUrl)}
                    title={current?.accessibilityTooltip}
                    aria-label={current?.accessibilityText}
                    $linkStyles={linkStyles}
                >
                    {getText(type, string, current)}
                </StyledLink>
            )
        }
        return <React.Fragment key={`sb-text-${partsIndex}`}>{string}</React.Fragment>
    })
    return replacedSections
}
